import { render, staticRenderFns } from "./DashboardAvailableObjectsSummary.vue?vue&type=template&id=5987a000&scoped=true&"
import script from "./DashboardAvailableObjectsSummary.vue?vue&type=script&lang=js&"
export * from "./DashboardAvailableObjectsSummary.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAvailableObjectsSummary.vue?vue&type=style&index=0&id=5987a000&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5987a000",
  null
  
)

export default component.exports